import { useSearch } from "@tanstack/react-router";

import { VerifyOTP } from "@/pages/Auth";

export function VerifyOtpRouteComponent() {
  const { mode, phone, email, from } = useSearch({
    from: "/auth/verify-otp",
  });

  return (
    <VerifyOTP
      mode={mode}
      phone={phone}
      email={email}
      from={from}
    />
  );
}
